/**
 * Converts USD amounts in the product price block subtitle
 * (snippets/price-subtitle-currency.liquid) into the block's selected currency,
 * rounded up to the next whole number.
 *
 * Rate source:
 *   1. Store's own Markets rate (Shopify.currency.rate) when the shopper is
 *      browsing in the target currency, so it matches checkout pricing.
 *   2. Otherwise Shopify's public daily rates (cdn.shopify.com currencies.js).
 * If no rate can be loaded, the original USD amount is shown.
 */
(function() {
  var SELECTOR = '[data-price-subtitle-currency]:not([data-converted])';
  var RATES_URL = 'https://cdn.shopify.com/s/javascripts/currencies.js';
  var ratesPromise = null;

  function loadPublicRates() {
    if (ratesPromise) return ratesPromise;
    ratesPromise = new Promise(function(resolve) {
      if (window.Currency && window.Currency.rates) {
        resolve(window.Currency.rates);
        return;
      }
      var s = document.createElement('script');
      s.src = RATES_URL;
      s.async = true;
      s.onload = function() { resolve(window.Currency && window.Currency.rates); };
      s.onerror = function() { resolve(null); };
      document.head.appendChild(s);
    });
    return ratesPromise;
  }

  function render(root, rate) {
    root.querySelectorAll('[data-usd-amount]').forEach(function(el) {
      if (rate) {
        var converted = parseFloat(el.dataset.usdAmount) * rate;
        // Round to cents first so float noise (38.0000001) doesn't bump the value up
        var whole = Math.ceil(Math.round(converted * 100) / 100);
        el.textContent = root.dataset.prefix + whole + root.dataset.suffix;
      }
      el.style.visibility = '';
    });
  }

  function convert(root) {
    root.setAttribute('data-converted', '');
    var target = root.dataset.currency;
    var sc = window.Shopify && window.Shopify.currency;

    if (sc && sc.active === target && root.dataset.shopCurrency === 'USD' && parseFloat(sc.rate)) {
      render(root, parseFloat(sc.rate));
      return;
    }

    loadPublicRates().then(function(rates) {
      // Public rates are USD value per 1 unit of each currency
      if (rates && rates.USD && rates[target]) {
        render(root, rates.USD / rates[target]);
      } else {
        render(root, null);
      }
    });
  }

  function convertAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(convert);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { convertAll(); });
  } else {
    convertAll();
  }

  // Quick shop modals inject product markup later
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches(SELECTOR)) convert(node);
        else convertAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
